<button
  [class]="btnClass"
  (click)="onClick.emit()"
  [type]="type"
  [attr.data-test-id]="btnId()"
  [disabled]="isSubmitting || isDisabled"
  >
  @if (!isSubmitting) {
    <ng-content></ng-content>
  }
  <span
    [ngClass]="{ 'spinner-border spinner-border-sm': isSubmitting }"
    role="status"
    aria-hidden="true"
  ></span>
  @if (isSubmitting) {
    <span class="sr-only">Loading...</span>
  }
</button>
